module.exports = __webpack_public_path__ + "static/media/fal_fal_lif_poi_eye.099991c8.png";